import { IDGenerator } from '@wm/core';

export const widgetIdGenerator = new IDGenerator('widget-id');
